import axios from "./AxiosService";

export function GetPolicyDetails() {
  return axios
    .get(
      "PolicyDetails",
      {},
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
    .then(response => {
      return response;
    });
}
